import axios from "axios";
import { apiUrl, logApiError } from "@/shared/services/config.js";
import {
  OpenOrderDetailsDto,
  SubmissionDetails,
} from "@/shared/dtos/index.js";

/**
 * GET /dashboard/submissions — list of submissions for the dashboard.
 * @returns {Promise<SubmissionDetails[]>}
 */
export const fetchDashboardSubmissions = async () => {
  try {
    const response = await axios.get(
      apiUrl("/dashboard/submissions"),
      { withCredentials: true },
    );
    const data = response.data;
    const rows = Array.isArray(data) ? data
      : Array.isArray(data?.data) ? data.data
      : Array.isArray(data?.rows) ? data.rows
      : Array.isArray(data?.submissions) ? data.submissions
      : [];
    return rows.map((r) => new SubmissionDetails(r));
  } catch (error) {
    logApiError(error);
    throw error;
  }
};

/** @returns {Promise<OpenOrderDetailsDto[]>} */
export const fetchInsuredOpenOrders = async () => {
  try {
    const response = await axios.get(
      apiUrl("/insured/orders/open"),
      { withCredentials: true },
    );
    return Array.isArray(response.data)
      ? response.data.map((o) => new OpenOrderDetailsDto(o))
      : [];
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401 || status === 403 || status === 404) return [];
    logApiError(error);
    return [];
  }
};
